<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
  components: {},
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
      if (parent) {
        parent.classList.add('mm-active')
        const parent2 = parent.parentElement.closest('ul')
        if (parent2 && parent2.id !== 'side-menu') {
          parent2.classList.add('mm-show')

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.add('mm-active')
            var childAnchor = parent3.querySelector('.has-arrow')
            var childDropdown = parent3.querySelector('.has-dropdown')
            if (childAnchor) childAnchor.classList.add('mm-active')
            if (childDropdown) childDropdown.classList.add('mm-active')

            const parent4 = parent3.parentElement
            if (parent4) parent4.classList.add('mm-show')
            const parent5 = parent4.parentElement
            if (parent5) parent5.classList.add('mm-active')
          }
        }
      }
    }
  },
  methods: {

  }
}
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <li class="menu-title">Меню</li>

      <li>
        <a target="_blank" href="https://chrome.google.com/webstore/detail/multiaccaunt/bcoiihabmfakmgppaccdhijkfgbbdjlj" class="side-nav-link-ref">
          <i :class="`bx bxl-chrome`" />
          <span>Установить расширение</span>
        </a>
      </li>

      <li>
        <router-link to="/subscription" class="side-nav-link-ref">
          <i :class="`bx bx-credit-card`" />
          <span>Моя подписка</span>
        </router-link>
      </li>

      <li>
        <router-link to="/profiles" class="side-nav-link-ref">
          <i :class="`bx bx-id-card`" />
          <span>Профили</span>
        </router-link>
      </li>

      <li>
        <router-link to="/proxies" class="side-nav-link-ref">
          <i :class="`bx bx-world`" />
          <span>Прокси</span>
        </router-link>
      </li>

      <li>
        <router-link to="/referral" class="side-nav-link-ref">
          <i :class="`bx bx-network-chart`" />
          <span>Партнёрская программа</span>
        </router-link>
      </li>

      <li>
        <router-link to="/faq" class="side-nav-link-ref">
          <i :class="`bx bx-question-mark`" />
          <span>FAQ</span>
        </router-link>
      </li>
    </ul>
  </div>
<!-- Sidebar -->
</template>
